<template>
  <div class="authentication-wrapper authentication-3">
    <div class="authentication-inner">

      <!-- Side container -->
      <!-- Do not display the container on extra small, small and medium screens -->
      <div class="d-none d-lg-flex col-lg-8 align-items-center ui-bg-cover ui-bg-overlay-container p-5"
           :style="{ backgroundImage: 'url(' + require('@/assets/backgroubd_2.jpg') + ')' }">
        <div class="ui-bg-overlay bg-dark opacity-50"></div>
        <!-- Text -->
        <div class="w-100 text-white px-5">
        </div>
        <!-- /.Text -->
      </div>
      <!-- / Side container -->

      <!-- Form container -->
      <div class="d-flex col-lg-4 align-items-center bg-white p-5">
        <!-- Inner container -->
        <!-- Have to add `.d-flex` to control width via `.col-*` classes -->
        <div class="d-flex col-sm-7 col-md-5 col-lg-12 px-0 px-xl-4 mx-auto">
          <div class="w-100">
            <div class="d-flex justify-content-center align-items-center">
              <div class="ui">
                <div class="w-100 position-relative" style="padding-bottom: 20%">
                  <img :src="require('@/assets/logo_opengraph.png')" style=""/>
                </div>
              </div>
            </div>
            <!-- / Logo -->

            <h4 class="text-center text-lighter font-weight-normal mt-1 mb-0">
              Connexion à la plateforme de continuité managariale
            </h4>
            <!-- Form -->
            <form class="my-5" @submit="login">
              <div  v-if="errors['global']" role="alert"
                    aria-live="polite" aria-atomic="true" class="alert alert-dismissible alert-dark-danger"
              >
                {{ errors['global'] }}
              </div>
              <div>

              </div>
              <b-form-group :label="$t('email')" class="position-relative">
                <b-input v-model="email"  :placeholder="$t('email')" :state="errors.email ? 'invalid': ''" />
                <div v-if="errors['email']" class="invalid-tooltip">{{ errors['email'][0] }}</div>
              </b-form-group>
              <b-form-group>
                <div slot="label" class="d-flex justify-content-between align-items-end">
                  <div>{{ $t('password')}}</div>
                  <a href="/forget-password/"  class="d-block small">{{$t('password_forgotten')}}</a>
                </div>
                <b-input :type="passwordFieldType" :placeholder="$t('password')" v-model="password" :state="errors.password ? 'invalid': ''"/>
                <div v-if="errors['password']" class="invalid-tooltip">{{ errors['password'][0] }}</div>
              </b-form-group>

              <div class="d-flex justify-content-between align-items-center m-0">
                <b-btn variant="primary" type="submit">{{ $t('login')}}</b-btn>
              </div>
            </form>
            <!-- / Form -->

            <div class="text-center text-muted">
              <a href="/confidentiality/">{{ $t('privacy')}}</a><br/>
              <a href="/legals/">{{ $t('legales')}}</a>&nbsp;-&nbsp;<a href="/cookies/">{{ $t('cookies_managment')}}</a>
            </div>

          </div>
        </div>
      </div>
      <!-- / Form container -->

    </div>
  </div>
</template>

<!-- Page -->
<style src="@/vendor/styles/pages/authentication.scss" lang="scss"></style>
<style>
  .password-eye {
    float:right;
    margin-right:20px;
    margin-top:-30px;
    position:relative;
  }
</style>
<script>
import { mapState } from 'vuex';
import { AUTH_REQUEST } from '../_store/authenticate/actiontypes';

export default {
  name: 'home',
  mounted() {
    if (this.$cookie.get('language') === 'fr' || this.$cookie.get('language') === 'en'){
      this.$i18n.locale = this.$cookie.get('language')
    } else {
      this.$cookie.set('language', 'fr', 300);
      location.reload();
    }
    
  },
  data() {
    return ({
      email: '',
      password: '',
      passwordFieldType: 'password',
    });
  },
  computed: mapState({ errors: state => state.authenticate.errors }),
  methods: {
    changeLanguage(language) {
      this.$cookie.set('language', language, 300);
      location.reload();
    },
    login(e) {
      e.preventDefault();
      const { email, password } = this;
      this.$store.dispatch(AUTH_REQUEST, {
        email,
        password,
      })
        .then(() => {
          this.$router.push('dashboard/');
        })
        .catch((error) => { console.log('error is =='); console.log(error)});
    },
  },
};
</script>
